import request from './request';
/**
 * 查询用户
 */
export function searchUser(params) {
    return request('/user/list', {
        method: 'POST',
        params,
    });
}

/**
 * 根据用户ID和组织ID获取用户详情
 */
export function getUserDetail(params) {
    return request('/user', {
        method: 'GET',
        params,
    });
}

/**
 * 根据用户手机号查询用户信息
 */
export function queryUserInfo(params) {
    return request('/user/phone', {
        method: 'GET',
        params,
    });
}

/**
 * 查询用户组织的角色
 */
export function queryRoleOptions(params) {
    return request('/user/org-role', {
        method: 'POST',
        params,
    });
}

/**
 * 查询当前组织的组织架构
 */
export function queryViewOptions(params) {
    return request(`/user/user-org/list/${params.orgId}`, {
        method: 'GET',
    });
}


/**
 * 新建用户
 */
export function addUser(params) {
    return request('/user', {
        method: 'POST',
        params,
    });
}

/**
 * 编辑用户
 */
export function editUser(params) {
    return request('/user', {
        method: 'PATCH',
        params,
    });
}

/**
 * 启用/禁用 用户
 */
export function activeUser(params) {
    return request('/user/active', {
        method: 'PATCH',
        params,
    });
}

/**
* 查询用户的操作记录
*/
export function getUserRecord(id, params) {
    return request(`user/record/${id}`, {
        method: 'GET',
        params,
    });
}
